/**
 * A singleton module for handling concurrency when refreshing tokens.
 * It keeps track of requests waiting for a refresh to complete (retryQueue)
 * and a flag (isRefreshing) indicating whether a refresh is in progress.
 */
const tokenRefreshQueue = (() => {
  // Private state
  let isRefreshing = false;
  let retryQueue = [];

  /**
   * Adds a request to the queue. Each queued item has a resolve/reject
   * that we call once the refresh completes.
   * @param {Function} resolve - Called when refresh is successful (receives the new token).
   * @param {Function} reject - Called if refresh fails.
   */
  const enqueue = (resolve, reject) => {
    retryQueue.push({ resolve, reject });
  };

  /**
   * Processes all queued requests after refresh either succeeded or failed.
   * @param {Error|null} error - If non-null, signals refresh failure.
   * @param {string|null} newToken - New token if refresh succeeded, or null if failed.
   */
  const processQueue = (error, newToken) => {
    retryQueue.forEach(({ resolve, reject }) => {
      if (error) {
        reject(error);
      } else {
        resolve(newToken);
      }
    });
    retryQueue = []; // Clear the queue
  };

  return {
    isRefreshing,
    enqueue,
    processQueue
  };
})();

export default tokenRefreshQueue;
